<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" md="8">
        <v-date-picker
          v-model="selectedDate"
          :allowed-dates="isDateAllowed"
          color="primary"
          no-title
          locale="pt-BR"
          width="450"
        ></v-date-picker>
      </v-col>
      <v-col cols="12" md="4">
        <ul>
          <v-radio-group v-model="selectedHour">
            <v-radio
              v-for="(slot, index) in schedulesForSelectedDate"
              :key="index"
              :label="`${slot.hour} - ${slot.to}`"
              :value="slot"
              style="margin-top: 1vw"
            ></v-radio>
          </v-radio-group>
        </ul>
        <p v-if="schedulesForSelectedDate.length === 0">Escolha um horário</p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "custom-datepicker",
  props: {
    horarios: {
      type: Array,
    },
  },
  data() {
    return {
      selectedDate: null,
      selectedHour: null,
    };
  },
  computed: {
    availableWeekDays() {
      // Dias da semana únicos: 1 (Seg) a 7 (Dom)
      return [...new Set(this.horarios.map((h) => h.weekDay))];
    },
    schedulesForSelectedDate() {
      if (!this.selectedDate) return [];

      const [y, m, d] = this.selectedDate.split("-");
      const date = new Date(y, m - 1, d);

      const jsDay = date.getDay();
      const convertedDay = jsDay === 0 ? 7 : jsDay;

      return this.horarios
        .filter((h) => h.weekDay === convertedDay)
        .sort((a, b) => a.hour.localeCompare(b.hour));
    },
  },
  methods: {
    isDateAllowed(dateStr) {
      const [y, m, d] = dateStr.split("-");
      const date = new Date(y, m - 1, d);

      const today = new Date();
      today.setHours(0, 0, 0, 0);

      if (date <= today) return false;

      const jsDay = date.getDay();
      const convertedDay = jsDay === 0 ? 7 : jsDay;

      return this.availableWeekDays.includes(convertedDay);
    },
    formatDate(dateStr) {
      const options = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      };
      return new Date(dateStr).toLocaleDateString("pt-BR", options);
    },
    getData() {
      return {
        selectedDate: this.selectedDate,
        selectedHour: this.selectedHour,
      };
    },
  },
};
</script>
